import { reactive } from 'vue';
import { estadosService } from '../service/estados-service';
import { paisesService } from '../service/paises-service';
import { selectUtils } from '../util/select.utils.js';

export const camposEnderecoStore = reactive({
    estados: null,
    paises: null,
    paisesSigla: null,
    isLoadingEstados: false,
    isLoadingPaises: false,

    async adquirirTodosOsCampos() {
        if (this.estados === null) {
            await this.atualizarEstados();
        }
        if (this.paises === null || this.paisesSigla === null) {
            await this.atualizarPaises();
        }
    },

    async atualizarEstados(estadosNovos) {
        if(this.isLoadingEstados) return;

        if (!!estadosNovos && this.estados != estadosNovos) {
            this.estados = estadosNovos;
        } else if (!!!estadosNovos && !!!this.estados) {
            this.isLoadingEstados = true;
            const listaTipos = await estadosService.listar({'page[limit]': 100});
            this.estados = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','sigla']]
            });
            this.isLoadingEstados = false;
        }
        return this.estados;
    },

    async atualizarPaises(paisesNovos, paisesSiglaNovos) {
        if(this.isLoadingPaises) return;

        if (!!paisesNovos && this.paises != paisesNovos) {
            this.paises = paisesNovos;
        }
        if (!!paisesSiglaNovos && this.paisesSigla != paisesSiglaNovos) {
            this.paisesSigla = paisesSiglaNovos
        }
        if (!!paisesNovos || !!paisesSiglaNovos) {
            return;
        }
        if (!!!this.paises || !!!this.paisesSigla) {
            this.isLoadingPaises = true;
            const listaTipos = await paisesService.listar({'page[limit]': 250});
            this.paises = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','nome']]
            });
            this.paisesSigla = selectUtils.ConverterDTOEmValoresParaSelect(listaTipos.data, {
                value: 'id',
                label: [['attributes','sigla']]
            });
            this.isLoadingPaises = false;
        }
        return this.paises, this.paisesSigla;
    }
})